import type { ReactNode } from 'react'
import type { Mission } from '@/lib'

export const templateIds = ['agency-home', 'service-landing', 'multi-step-form', 'search-results'] as const
export type TemplateId = (typeof templateIds)[number]

/** Where a link to another template points: a preview route on the site, a file in the HTML export. */
export type TemplateLink = (id: TemplateId) => string

/** The site route that shows a template as a whole page. */
export const previewPath: TemplateLink = (id) => `/templates/${id}/preview`

export type TemplateProps = {
  mission: Mission
  link: TemplateLink
  /** A line for the footer, such as who made the site. */
  credit?: ReactNode
}
